<template>
  <GenericTaskCreationStep
    class="select-import-request-dialog"
    v-on="$listeners"
  >
    <template v-slot:title>Select an Import Request</template>
    <template>
      <v-card-text>
        For external PIMs matching, the Matcher Task expects a
        <b>FULL</b>
        import request that has been
        <b>COMPLETED</b>
        . Most commonly with the source type
        <b>EXPORTER</b>
        , indicating the source data has been preprocessed and the data is ready
        to be matched. A completed import request is
        <b>not</b>
        required for internal related tasks such as local food catalog matching.
      </v-card-text>
      <v-data-table
        class="p-10"
        :value="importRequest ? [importRequest] : []"
        v-on:input="(items) => $emit('updateImportRequest', items[0])"
        :loading="isLoading"
        :headers="importRequestHeaders"
        :items="importRequests"
        :single-select="true"
        :disable-sort="true"
        :server-items-length="totalImportRequests"
        :items-per-page="itemsPerPage"
        @update:page="fetchMoreImportRequests"
        @update:items-per-page="updateItemsPerPage"
        item-key="id"
        show-select
      />
    </template>
  </GenericTaskCreationStep>
</template>

<style>
.select-import-request-dialog {
  width: 1000px;
}
</style>

<script>
import GenericTaskCreationStep from './GenericTaskCreationStep.vue';

import CONFIG from '@/config';
import { businessApiV2 } from '@/api/v2';

export default {
  props: {
    importSessionId: String,
    importRequest: Object
  },
  data() {
    return {
      isLoading: false,
      importRequestHeaders: [
        { text: 'id', value: 'id' },
        { text: 'type', value: 'type' },
        { text: 'source', value: 'source' },
        { text: 'status', value: 'status' },
        { text: 'creationDate', value: 'creationDate' }
      ],
      page: 1,
      itemsPerPage: 10,
      totalImportRequests: 0,
      importRequests: []
    };
  },
  async created() {
    this.fetchMoreImportRequests();
  },
  methods: {
    async fetchMoreImportRequests(page = 1) {
      this.isLoading = true;
      const { data, totalCount } =
        await businessApiV2.fetchSessionImportRequests({
          sessionId: this.importSessionId,
          environment: CONFIG.ENV,
          from: this.itemsPerPage * page - this.itemsPerPage,
          to: this.itemsPerPage * page - 1,
          types: ['FULL']
        });
      this.importRequests = data;
      this.totalImportRequests = totalCount;
      this.isLoading = false;
    },
    updateItemsPerPage(itemsPerPage) {
      this.itemsPerPage =
        itemsPerPage > 0 ? itemsPerPage : this.totalImportRequests;
      this.fetchMoreImportRequests();
    }
  },
  components: { GenericTaskCreationStep }
};
</script>
